import { useEffect, useState } from 'react';

export function Timer({ deadline, totalMs }: { deadline: number; totalMs: number }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = window.setInterval(() => setNow(Date.now()), 250);
    return () => clearInterval(t);
  }, []);
  const remainingMs = Math.max(0, deadline - now);
  const pct = Math.max(0, Math.min(100, (remainingMs / totalMs) * 100));
  const sec = Math.ceil(remainingMs / 1000);
  const danger = pct < 20;
  return (
    <div className="flex items-center gap-3">
      <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-panel-2">
        <div
          className="h-full rounded-full transition-[width] duration-200 ease-linear"
          style={{
            width: `${pct}%`,
            background: danger ? 'var(--color-danger)' : 'var(--color-accent)',
          }}
        />
      </div>
      <span
        className={`min-w-[3ch] text-right font-mono text-sm font-semibold tabular-nums ${
          danger ? 'text-danger' : 'text-fg'
        }`}
      >
        {sec}s
      </span>
    </div>
  );
}
